import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication
import Login from './auth/login/reducer';
import Account from './auth/register/reducer';
import User from './auth/user/reducer';

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  User,
});

export default rootReducer;
